import {Component, Input, Output, EventEmitter, OnChanges, SimpleChanges} from '@angular/core';
import {NgIf, NgOptimizedImage} from "@angular/common";

@Component({
    selector: 'app-device-card',
    templateUrl: './device-card.component.html',
    standalone: true,
    imports: [
        NgIf,
        NgOptimizedImage
    ],
    styleUrls: ['./device-card.component.scss']
})
export class DeviceCardComponent {
    @Input() device: any;
    @Input() isSelected: boolean | undefined;
    @Output() deviceClick = new EventEmitter<any>();
    isOnline = false

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['device'] && this.device) {
            this.isOnline = this.device?.status === 'online';
        }
    }

    onDeviceClick() {
        this.deviceClick.emit(this.device);
    }

    getImageUrl(deviceModelId: string): string {
        const placeholderPath = 'assets/images/placeholder.png';
        if (deviceModelId) {
            const prefix = deviceModelId.substring(0, 4).toUpperCase();
            if (prefix.startsWith('N') || prefix.startsWith('D')) {
                return `assets/images/products/NVRDVR.png`;
            }
            if (prefix.startsWith('L')) {
                return placeholderPath;
            }
            if (
                this.deviceImages.some((imageId: string) =>
                    imageId.toUpperCase().startsWith(prefix)
                )
            ) {
                return `assets/images/products/${prefix}.png`;
            }
        }
        return placeholderPath;
    }

    deviceImages: string[] = [
        'N881', 'D241', 'placeholder', 'W482', 'W881', 'W452', 'B451',
        'W891', 'B463', 'B862', 'F861', 'F461', 'W261', 'ACCH', 'W463', 'SL30'
    ];
}
